import React from 'react';
import '../css/animations.scss';
// import { Link } from 'react-router-dom';

const Animations = () => {

  return (
    <div id="animations">
      <div id="title">
        <h1>Animations</h1>
      </div>
      <div id="content">
        <p>Voici un aperçu des animations que nous pouvons vous proposer.
        </p><p>
<span className="section">Un artiste en jonglerie déambulation :</span> Avec ses massues, son diabolo ou son monocycle, ce jongleur apporte de l'animation et déclenche de l'émerveillement et des sourires sur son passage.
</p>
<div className='flex flex-wrap'>
  <img className="h" alt='jonglerie 1' src='/images/creacirque/image0.jpeg' />
  <img className="h" alt='jonglerie 2' src='/images/creacirque/image1.jpeg' />
  <img className="v" alt='jonglerie 3' src='/images/creacirque/image2.jpeg' />
  <img className="v" alt='jonglerie 4' src='/images/creacirque/image3.jpeg' />
  <img className="v" alt='jonglerie 5' src='/images/creacirque/image4.jpeg' />
  <img className="v" alt='jonglerie 6' src='/images/creacirque/image5.jpeg' />
  <img className="h" alt='jonglerie 7' src='/images/creacirque/image6.jpeg' />
</div>
<p>
<span className="section">Un artiste en échassier d'accueil :</span> Du haut de ses grandes jambes, cet échassier se promène dans la foule et apporte la bonne humeur en accueillant la foule.
</p><p>
<span className="section">Un artiste en échassier + sculpture de ballons :</span> Du haut de ses grandes jambes, ce personnage déambule en offrant des sculptures de ballons colorées et originales.
</p><p><span className="section">Un artiste sculpteur de ballons :</span>  Cet artiste apportera couleur et gaieté en offrant fleurs, petits chiens, oursons, épées ou autre fantaisie sculptée en ballons multicolores. Cet artiste peut déambuler en personnage de clown ou de pirate.
</p><p><span className="section">Un espace cirque :</span> Petits et grands pourront découvrir et s'initier aux diverses disciplines de cirque: la jonglerie avec les balles, les massues, le diabolo, le bâton du diable... ou l'équilibre avec les échasses, le pédalgo, le monocycle, la boule d'équilibre.... C'est l'occasion de se découvrir des capacités insoupçonnées et de renforcer sa confiance en soi!
Une artiste grimeuse:  Grâce à ses pinceaux magiques, les enfants pourront se transformer en animal fantastique, super héros.oïnes ou tout autre personnage issu de leur imagination!
</p><p>
  
</p><p>
Duo Tamba
</p><p>
Emoi
</p><p>
Fiche technique :
</p>
<ul>
  <li>Un espace de jeux de +- 60m carrés.</li>
  <li>Un sol stable plat (votre pelouse convient)</li>
  <li>Une alimentation électrique 220 V</li>
  </ul>

  <p>Description du spectacle :<br/>
    Deux êtres tantôt complices, tantôt adversaires, vont se parasiter l’un l’autre, se provoquer se retrouver, poussant les états émotionnels à la caricature.<br/>
    La jonglerie, l’acrobatie et la musique animent ces deux personnages dans l’instant présent. Pour la plus grande joie de toutes et tous!
  </p>
      </div>
    </div>
  )
};

export default Animations;
